module.exports = () ->
  return {

    restrict: 'A'

    template: require('./Form.html')

    scope:
      getStepTemplate: '&stepTemplate'
      getStepConfig:   '&stepConfig'
      countries:       '='
      workflowForm:    '='

    controller: ( $scope, $element ) ->

      return
  }
